import { parsePhoneNumber } from 'libphonenumber-js';

export interface FormattedPhone {
  national: string;
  international: string;
}

/**
 * Parse and format a phone number string into national and international formats.
 * Falls back to 'BR' country code if initial parsing fails.
 * Returns the raw string for both formats if all parsing fails.
 */
export function formatPhoneForDisplay(phone: string): FormattedPhone {
  try {
    let phoneNumber = parsePhoneNumber(phone);
    if (!phoneNumber) {
      phoneNumber = parsePhoneNumber(phone, 'BR');
    }
    if (phoneNumber) {
      return {
        national: phoneNumber.formatNational(),
        international: phoneNumber.formatInternational(),
      };
    }
  } catch {
    try {
      const phoneNumber = parsePhoneNumber(phone, 'BR');
      if (phoneNumber) {
        return {
          national: phoneNumber.formatNational(),
          international: phoneNumber.formatInternational(),
        };
      }
    } catch {
      // If both fail, return as is
    }
  }
  return { national: phone, international: phone };
}
